<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-13 22:32:35
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:25:15
 * @Description: file content
 -->

<template>
  <div>
    <!-- 专属分享 -->
    <div class="masks">
      <div class="popup-layers animated zoomIn">
        <div class="popups">
          <div class="pop-titles">存通讯录</div>
          <div class="pop-content">
            <div class="box">
              <input
                id="saveAddressListIds_smsinput"
                class="username"
                placeholder="请输入手机号码"
                v-model="phone"
              />
            </div>
            <div class="vali">
              <div class="box1">
                <input
                  v-model="smsCode"
                  id="saveAddressListIds_smscode"
                  class="username"
                  value
                  placeholder="请输入验证码"
                />
              </div>
              <div id="saveAddressListIds_smsbtn" class="vali_btn">获取</div>
            </div>

            <div class="intro">{{cardInfo.Ui.Name}}的详细信息立刻短信发给您</div>
          </div>
          <div class="pop-btns">
            <div class="btn" @click="clickOk">确定</div>
          </div>
        </div>
        <div class="closes" @click="clickClose"></div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import request from "@/utils/request";
import Cookies from "js-cookie";
import { mapState, mapMutations } from "vuex";
import * as validate from "@/utils/validate";
export default {
  components: {},
  props: {},
  data() {
    return {
      phone: "",
      smsCode: ""
    };
  },
  watch: {
     smsCode: function(newVal, oldVal) {
      if (this.smsCode.length > 8) {
        this.smsCode = this.smsCode.substring(0, this.smsCode.length/2);
      }
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    // 关闭
    clickClose() {
      this.$emit("close");
    },
    valiFrom() {
      let valiResult = true;
      if (validate.isEmptyString(this.phone)) {
        util.messageBox("手机号码不能为空！");
        valiResult = false;
      } else if (!validate.isMobile(this.phone)) {
        util.messageBox("手机号码格式不正确！");
        valiResult = false;
      } else if (validate.isEmptyString(this.smsCode)) {
        util.messageBox("验证码不能为空！");
        valiResult = false;
      }
      return valiResult;
    },
    // 确定
    clickOk() {
      if (this.valiFrom()) {
        comreq
          .addToContacts(this.cardInfo.User.Id, this.phone, this.smsCode)
          .then(() => {
            util.messageBox("发送成功!").then(() => {
              this.$emit("close");
            });
          });
      }
    }
  },
  created() {},
  mounted() {
    validate.bindSendSmsCode(
      "saveAddressListIds_smsinput",
      "saveAddressListIds_smscode",
      "saveAddressListIds_smsbtn",
      "获取",
      "%S",
      60
    );
  }
};
</script>
<style lang="stylus" scoped>
// 专属
.masks {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 35;
}

.popup-layers {
  position: absolute;
  left: 50px;
  right: 50px;
  top: 25%;
  background: transparent;
}

.popup-layers .popups {
  width: 100%;
  background-color: #ffffff;
  position: relative;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.popups .pop-titles {
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  font-weight: 600;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/share-after-action/pop-titles_bg.png');
  background-size: 100% 100%;
  position: absolute;
  min-width: 50%;
  padding: 0 20px;
  top: -5px;
}

// 内容
.popups .pop-content {
  margin-top: 45px;
  margin-bottom: 25px;
  width: 90%;
  // background: rgba(250, 250, 250, 1);
  // box-shadow: 0px 3px 7px 0px rgba(139, 64, 64, 0.78);
  // border-radius: 5px;
  text-align: center;
}

.popups .pop-content .box {
  width: 100%;
  height: 50px;
}

.popups .pop-content .box input {
  width: 100%;
  height: 36px;
  line-height: 36px;
  border-radius: 5px;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/save-address-list/icon_phone.png') no-repeat;
  background-color: white;
  background-position: top 8.5px left 10px;
  background-size: 10px 15px;
  border: 1px solid #EC5967;
  outline: none;
  box-sizing: border-box;
  padding-left: 25px;
}

.popups .pop-content .vali {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.popups .pop-content .vali .box1 {
  width: 70%;
  height: 50px;
}

.popups .pop-content .vali .box1 input {
  width: 100%;
  height: 36px;
  line-height: 36px;
  border-radius: 5px;
  background: url('https://assets.wxmp.ruthus.com/henduoke/register/icon_valicode.png') no-repeat;
  background-color: white;
  background-position: top 8.5px left 7px;
  background-size: 15px 15px;
  border: 1px solid #EC5967;
  outline: none;
  box-sizing: border-box;
  padding-left: 25px;
}

.popups .pop-content .vali .vali_btn {
  width: 25%;
  font-size: 14px;
  color: #333333;
  height: 36px;
  line-height: 36px;
  background-color: #F97172;
  color: #ffffff;
  border-radius: 5px;
}

.popups .pop-content .intro {
  font-size: 14px;
  color: #333333;
}

.popups .pop-btns {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.popups .pop-btns .btn {
  width: 80%;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  background-color: #F97172;
  color: #ffffff;
  font-size: 12px;
  margin-bottom: 20px;
}

.closes {
  width: 0.88rem;
  height: 0.88rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/new-close.png') no-repeat center center; // assets.rurushishi.com/yq-rs-make/components/mask/new-close.png) no-repeat center center;
  background-size: 0.64rem 0.64rem;
  z-index: 35;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>


